import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalErrorHandler } from '../error.handler';

/**
 * Guard that prevents navigation to exception view if no exception has been thrown.
 * Prevents user from visiting the view by entering manually link to view.
 */
@Injectable({
  providedIn: 'root'
})
export class ExceptionViewGuard  {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let canActivate = GlobalErrorHandler.isFatalError;
    if (canActivate == false) {
      return this.router.parseUrl('');
    }
    else {
      return true;
    }
  }
  
}
